<template>
  <div
    :id="'boss-modal-control-'+userId"
    class="reveal boss-modal-container-resume"
    data-reveal
    @scroll="onScroll"
  >
    <h2
      class="boss-title"
      data-test="resume-updated-date"
    >
      会員レジュメ（{{ resumeUpdateDate }}更新）
    </h2>
    <!-- ▼レジュメカード -->
    <section
      class="boss-resumecard-item"
    >
      <!-- 詳細のアバターはチェックボックス必ず非表示のためfalse -->
      <scout-resume-card-avatar
        :id="userId"
        :member="member"
        :is-show-checkbox="false"
        :is-show-scout-decline="isShowScoutDecline"
      />
      <div class="boss-resumecard-item-right">
        <div class="boss-resumecard-details">
          <div class="boss-resumecard-overview clearfix">
            <div
              class="boss-resumecard-overview-title"
              data-test="member-summary"
            >
              {{ getNameOrUndefined(member, 'presentAddressPrefecture.name') | parseBlankForDefaultValue('--', '', '', false) }} {{ member.birthdate | parseAge | parseBlankForDefaultValue('--', '', '歳', false) }} {{ getNameOrUndefined(member, 'gender.name') | parseBlankForDefaultValue('--', '', '', false) }} /{{ member.employed | convertEmployedLabel | parseBlankForDefaultValue('--', '', '', false) }} /{{ member.careerResumes && member.careerResumes.length > 0 ? member.careerResumes[0].annualSalary : null | parseNumberValue('--', '年収', '万円', false) }} /{{ member.changeOverJobsCount | parseNumberValue('--', '転職', '回', false) }}
            </div>
            <dl class="boss-resumecard-overview-list clearfix">
              <dt class="boss-resumecard-overview-item">
                <span class="boss-resumecard-head">直近の経験職種</span>
              </dt>
              <dd
                class="boss-resumecard-overview-body"
                data-test="member_experienced_occupation"
              >
                {{ convertSliceObjectLabelSuffixYear(member.experiencedOccupations, 0, 1) | parseBlankForDefaultValue('') }}
              </dd>
            </dl>
            <dl class="boss-resumecard-overview-list clearfix">
              <dt class="boss-resumecard-overview-item">
                <span class="boss-resumecard-head">希望職種</span>
              </dt>
              <dd
                class="boss-resumecard-overview-body"
                data-test="member_desired_occupation"
              >
                {{ convertSliceObjectLabel(member.desiredOccupations, 0, 1) | parseBlankForHopeValue() }}
              </dd>
            </dl>
            <div class="boss-layout boss-layout-no-gap">
              <dl class="boss-resumecard-overview-list">
                <dt class="boss-resumecard-overview-item">
                  <span class="boss-resumecard-head">希望勤務地</span>
                </dt>
                <dd
                  class="boss-resumecard-overview-body"
                  data-test="member_desired_work_prefecture"
                >
                  {{ convertSliceArrayLabel(member.desiredWorkPrefectures, 0, 1) | parseBlankForHopeValue() }}
                </dd>
              </dl>
              <dl class="boss-resumecard-overview-list">
                <dt class="boss-resumecard-overview-item">
                  <span class="boss-resumecard-head">希望年収</span>
                </dt>
                <dd
                  class="boss-resumecard-overview-body"
                  data-test="member_desiredSalary"
                >
                  {{ member.desiredSalary | parseBlankForDefaultValue('', '', '万円') }}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ▲レジュメカード -->
    <!-- ▼職務経歴書 -->
    <scout-member-career-resume
      v-if="!isMaskingTarget"
      :member="member"
    />
    <div
      v-else
      data-test="masking"
      class="margin-top-1"
    >
      {{ maskingLabel }}
    </div>
    <!-- ▲職務経歴書 -->
    <!-- ▼コメント -->
    <template v-if="showDetail">
      <scout-member-comment
        :user-id="userId"
        @update-comment="updateComment"
      />
    </template>
    <!-- ▲コメント -->
    <!-- ▼早見表 -->
    <template v-if="contractId && showDetail">
      <scout-member-scout-summary
        :user-id="userId"
        :contract-id="contractId"
      />
    </template>
    <!-- ▲早見表 -->
    <!-- ▼ スカウト送信履歴 -->
    <template v-if="contractId && jobId && showDetail">
      <scout-member-scout-history
        :contract-id="contractId"
        :job-id="jobId"
        :user-id="userId"
        data-test="scout-history"
        :is-show-more-history="isShowMoreHistory"
        @update:isShowMoreHistory="$emit('update:isShowMoreHistory', $event)"
      />
    </template>
    <!-- ▲ スカウト送信履歴 -->
    <!-- ▼☓ボタン -->
    <button
      class="close-button boss-close-button boss-icon-cross"
      data-close
      aria-label="Close modal"
      type="button"
    />
    <!-- ▲☓ボタン -->
    <!-- ▼設定を閉じるボタン -->
    <div class="boss-modal-close">
      <button
        v-if="isShowCheckedCloseButton"
        class="boss-button-center boss-button-large boss-modal-selected-close-button"
        data-close
        aria-label="Close modal"
        type="button"
        data-test="checked-close-button"
        @click="check"
      >
        選択して閉じる
      </button>
      <button
        v-if="showsExcludedButton"
        class="boss-button-center boss-button-large"
        data-close
        aria-label="Close modal"
        type="button"
        data-test="excluded-close-button"
        @click="registerExcludedMember"
      >
        除外者へ
      </button>
      <button
        class="boss-button-center boss-button-large boss-modal-close-button"
        data-close
        aria-label="Close modal"
        type="button"
        data-test="close-button"
      >
        閉じる
      </button>
      <a
        v-scroll-to="{ element: `#boss-modal-control-${userId}`, container: `#boss-modal-control-${userId}`, duration: 500 }"
        class="boss-top-scroll"
        data-test="scroll-top"
      >
        <span class="boss-icon-triangle-up" />
        <span class="boss-top-scroll-text">上まで戻る</span>
      </a>
    </div>
    <!-- ▲設定を閉じるボタン -->
  </div>
</template>

<script>
import { createDate } from '@/lib/dateUtils.js'
import * as definition from '@/lib/labelValueMappings'
import _ from 'lodash'
import ScoutResumeCardAvatar from '@/components/molecules/ScoutResumeCardAvatar'
import ScoutMemberCareerResume from '@/components/molecules/ScoutMemberCareerResume'
import ScoutMemberScoutSummary from '@/components/molecules/ScoutMemberScoutSummary'
import ScoutMemberScoutHistory from '@/components/molecules/ScoutMemberScoutHistory'
import ScoutMemberComment from '@/components/molecules/ScoutMemberComment'
import * as parse from '@/lib/parse'
import { hideAllPoppers } from 'floating-vue'

export default {
  components: {
    ScoutResumeCardAvatar,
    ScoutMemberCareerResume,
    ScoutMemberScoutSummary,
    ScoutMemberScoutHistory,
    ScoutMemberComment
  },
  filters: {
    // 第1引数（label）が真偽判定で偽となる値（nullとか''とか0とかfalseとか...）の場合は
    // 第2引数（unregisterdValue）+ '未登録' を返却する
    // それ以外の場合は 第3引数(prefix) + 第1引数（label）+ 第4引数（suffix）を返却する
    // 第5引数はlabelが無効の時に未登録を付与するかどうか
    parseBlankForDefaultValue (label, unregisteredValue, prefix = '', suffix = '', isUnregisteredLabel = true) {
      return label ? prefix + label + suffix : isUnregisteredLabel ? unregisteredValue + '未登録' : unregisteredValue
    },
    // 第1引数（label）が真偽判定で偽となる値（nullとか''とか0とかfalseとか...）の場合は
    // 'こだわらない・未入力' を返却する
    // それ以外の場合は 第3引数(prefix) + 第1引数（label）+ 第4引数（suffix）を返却する
    parseBlankForHopeValue (label, prefix = '', suffix = '') {
      return label ? prefix + label + suffix : 'こだわらない・未入力'
    },
    parseNumberValue (value, unregisteredValue, prefix = '', suffix = '', isUnregisteredLabel = true) {
      return parse.numberValue(value, suffix, unregisteredValue, prefix, isUnregisteredLabel)
    },
    parseValueUnit (value, option) {
      const label = option.label ? option.label : ''
      const unit = option.unit ? option.unit : ''
      return value ? label + value + unit : ''
    },
    parseAge (birthdateString) {
      return parse.age(birthdateString)
    },
    convertEmployedLabel (value) {
      return value || value === false ? definition.employed.find(employed => employed.value === value).name : ''
    }
  },
  props: {
    jobId: {
      type: Number,
      default: null
    },
    userId: {
      type: Number,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    contractId: {
      type: Number,
      default: null
    },
    showDetail: {
      type: Boolean,
      default: false
    },
    isShowCheckedCloseButton: {
      type: Boolean,
      default: true
    },
    searchConditionName: {
      type: String,
      default: ''
    },
    showsExcludedButton: {
      type: Boolean,
      default: false
    },
    isShowScoutDecline: {
      type: Boolean,
      default: false
    },
    isShowMoreHistory: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      member: {},
      loading: true
    }
  },
  computed: {
    resumeUpdateDate () {
      return createDate(this.member.updateDate)?.format('YYYY/MM/DD')
    },
    isMaskingTarget () {
      return _.get(this.member, 'isCkUser') || _.get(this.member, 'isScoutRejection') || _.get(this.member, 'isWithdrawn') || !_.get(this.member, 'subscriptions.scout')
    },
    maskingLabel () {
      const label = _.get(this.member, 'isWithdrawn') ? '退会済み' : '利用停止'
      return this.loading ? '' : `${label}のため表示できません。`
    }
  },
  watch: {
    showDetail (val) {
      val && this.fetchMemberDetail(this.userId)
    },
    member (val) {
      this.loading = _.isEmpty(val)
    }
  },
  methods: {
    onScroll () {
      hideAllPoppers()
    },
    fetchMemberDetail (userId) {
      this.$http.secured.get(`/scout/view/users/${userId}`)
        .then(response => this.setProperty(response))
    },
    setProperty (response) {
      this.$set(this, 'member', response.data)
    },
    getNameOrUndefined (val, path) {
      return _.get(val, path)
    },
    convertSliceObjectLabelSuffixYear (value, begin, end) {
      if (!value || !value.length) return ''
      return value.slice(begin, end).map(v => {
        const label = this.getNameOrUndefined(v, 'name') + ' '
        const yearLabel = v.years !== null ? (v.years === 0 ? '1ヶ月以上' : v.years + '年') : '経験年数未設定'
        return label + yearLabel
      }).join('、')
    },
    convertSliceObjectLabel (value, begin, end) {
      if (!value || !value.length) return ''
      return value.slice(begin, end).map(v => {
        return this.getNameOrUndefined(v, 'name')
      }).join('、')
    },
    convertSliceArrayLabel (value, begin, end) {
      if (!value) return ''
      return value.slice(begin, end).map(v => this.getNameOrUndefined(v, 'name')).join('、')
    },
    check () {
      this.$emit('check-from-child', this.id)
    },
    updateComment (comment) {
      this.$emit('update-comment', comment)
    },
    registerExcludedMember () {
      this.$http.secured.post('/scout/view/company/excluded_users', [{ userId: this.userId, searchConditionName: this.searchConditionName }]).then(() => {
        this.$toasted.global.success({ message: '除外者一覧へ登録しました。' })
        this.$set(this.member, 'isScoutExcluded', true)
        this.$emit('update-member-excluded')
      })
    }
  }
}
</script>
